import { searchPeers } from '../../../actions/odooFormActions';
import { types } from '../../../utils/optionUtils';
import { getQueryParams } from '../../../utils/queryUtils';
import SelectField from '../formFields/SelectField';
import TextField from '../formFields/TextField';
import SearchPeerResults from './SearchPeerResults';
import PropTypes from 'prop-types';
import { useMemo, useRef, useState } from 'react';
import { Field, Form } from 'react-final-form';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';

const limit = 20;

const SearchPeerForm = ({ sessionId, searchPeers, searching, breadCrumbs }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const history = {
    push: navigate,
  };

  const [page, setPage] = useState(0);
  const queryParams = useMemo(() => getQueryParams(location.search), [location.search]);
  const lastValuesRef = useRef(null);

  const handleSubmit = (values) => {
    lastValuesRef.current = values;
    searchPeers(sessionId, values);
  };

  const handlePageChange = (newPage) => {
    if (!lastValuesRef.current) return;
    const values = { ...lastValuesRef.current, start: lastValuesRef.current.limit * newPage };
    searchPeers(sessionId, values);
    setPage(newPage);
  };

  return (
    <div className="container content">
      <div className="bg-light-grey">
        <Form
          initialValues={{
            limit,
            EligibleOnly: 1,
            start: 0,
            sessionId,
          }}
          onSubmit={handleSubmit}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Field name="sessionId" component="input" type="hidden" />
              <section className="search">
                <div className="row">
                  <div className="col-md-4">
                    <div className="inner">
                      <span className="icon fi fi-stack fi-lg">
                        <i className="fi fi-circle fi-stack-2x"></i>
                        <i className="fi fi-search fi-stack-1x"></i>
                      </span>
                      <div className="heading">
                        <h3 className="lead-in">Find a registered oral health practitioner</h3>
                      </div>
                      <div className="clearfix"></div>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <Field
                      name="Practice"
                      component={SelectField}
                      label="Search all or filter by type of practice"
                      cssClass="no-indent"
                      autocomplete
                      options={types}
                    />
                    <Field name="Surname" component={TextField} label="Search by surname" cssClass="no-indent" type="text" />
                    <Field
                      name="Name"
                      component={TextField}
                      label="Search by part of surname or first names"
                      cssClass="no-indent"
                      type="text"
                    />
                    <Field
                      name="Address"
                      component={TextField}
                      label="Search by address or part of address"
                      cssClass="no-indent"
                      type="text"
                    />
                    <Field name="PersonID" component={TextField} label="Search by Person ID" cssClass="no-indent" type="text" />
                  </div>

                  <div className="col-md-4 search-actions">
                    <button className="btn btn-primary" disabled={searching} type="submit">
                      Search
                    </button>
                  </div>
                </div>

                <div className="row-bottom">
                  <p className="search-additional-info">Click on the name of the practitioner you want to select</p>
                </div>
              </section>
            </form>
          )}
        />
      </div>

      <SearchPeerResults
        history={history}
        limit={limit}
        onPageChange={handlePageChange}
        page={page}
        queryParams={queryParams}
        searching={searching}
        breadCrumbs={breadCrumbs}
      />
    </div>
  );
};

SearchPeerForm.propTypes = {
  peers: PropTypes.array,
};

const mapStateToProps = (state) => ({
  searching: state.odooForm.searching,
  sessionId: state.user.sessionId,
});

const mapDispatchToProps = {
  searchPeers,
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPeerForm);
